import { ModuleWithProviders, NgModule, Optional, SkipSelf, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgmCoreModule, MapsAPILoader, LAZY_MAPS_API_CONFIG } from '@agm/core';
import { RecaptchaModule, RECAPTCHA_SETTINGS, RecaptchaSettings } from 'ng-recaptcha';

import { InMemoryWebApiModule } from 'angular-in-memory-web-api';
import { LocalDatabase } from './localdatabase';
import { Configuration } from './index.model';

import { environment } from '../../environments/environment';

import * as Services from './index.service';

import { CustomLazyAPIKeyLoader } from './MapApiClass';

export function ConfigLoader(configService: Services.ConfigService) {
    //Note: this factory need to return a function (that return a promise)
    configService.load(environment.configFile);
    
    return () => configService.load(environment.configFile);
}



const CSP_CORE_PROVIDERS = [
    Services.CommonService,
    Services.DataService,
    Services.LocalDataService,
    Services.AddressService,
    Services.CodedService,
    Services.ParameterConfigService,
    Services.PasswordService,
    Services.JurismgmtService,
    Services.LoginService,
    Services.TenantService,
    Services.PageContentService,
    Services.SessionStorageService,
    Services.Citizen_Role,
    Services.Admin_Role,
    Services.SuperAdmin_Role,
    Services.SystemParameter_Role,
    Services.ParamService,
    Services.NewsLetterService,
    Services.ConfigService,
    {
        provide: APP_INITIALIZER,
        useFactory: ConfigLoader,
        deps: [Services.ConfigService],
        multi: true
    },
    { provide: LAZY_MAPS_API_CONFIG, MapsAPILoader, useClass: CustomLazyAPIKeyLoader },
    Services.RefreshService,
    Services.CSPReportService,
];

@NgModule({
    imports: [
        CommonModule,
        AgmCoreModule.forRoot(),
        RecaptchaModule.forRoot(),
        InMemoryWebApiModule.forRoot(LocalDatabase, { passThruUnknownUrl: true }),
    ]
})
export class CoreModule {
    constructor( @Optional() @SkipSelf() parentModule: CoreModule) {
        throwIfAlreadyLoaded(parentModule, 'CoreModule');
    }

    static forRoot(): ModuleWithProviders {
        return <ModuleWithProviders>{
            ngModule: CoreModule,
            providers: [
                ...CSP_CORE_PROVIDERS,
            ],
        };
    }
}


export function throwIfAlreadyLoaded(parentModule: any, moduleName: string) {
    if (parentModule) {
        throw new Error(`${moduleName} has already been loaded. Import Core modules in the AppModule only.`);
    }
}



// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/core/core.module.ts